export const INDEPENDENT_PAGE_TYPE = 'Independent';
export const ATTRIBUTE_PAGE_TYPE = 'Attribute';
export const OPEN_ROLE_PAGE_TYPE = 'Open Role';
export const OPEN_ROLE_TYPE_KEY = 'open-role';
